// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { setISODay as fn } from "../setISODay.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const setISODay = convertToFP(fn, 2);

// Fallback for modularized imports:
export default setISODay;
